<template>
  <div class="fixed-center text-center">
    <p>
      <img
        src="../../assets/logo.png"
        style="width:30vw;max-width:150px;"
      >
    </p>
    <p class="text-faded">We can't reach the server.  Please check that you have an internet connection.</p>
    <q-btn
      color="primary"
      style="width:200px;"
      @click="refreshPage"
    >Try Again</q-btn>
  </div>
</template>
<script>
export default {
  methods: {
    refreshPage () {
      location.reload()
    }
  }
}
</script>
